/**
 * 1L2C REST API
 * Specification of REST API for 1Life2Connect Project
 *
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { CommunityStatus } from './communityStatus';
import { LocationObject } from './locationObject';
import { Viewport } from './viewport';

export interface CreateCommunityRequestBasic { 
    title: string;
    description: string;
    website?: string;
    type: string;
    location: LocationObject;
    viewport: Viewport;
    status: CommunityStatus;
    linked_communities?: Array<string>;
}